import * as yup from 'yup'

export const customTest = base => yup.object(base)
.test(
  'entry-number-range-valid', // test name
  'Range Start cannot be greater than Range End.', // error message
  function (value) {
    const { entryNumberRangeStart, entryNumberRangeEnd } = value;
    if (entryNumberRangeStart && entryNumberRangeEnd
      && entryNumberRangeStart > entryNumberRangeEnd) {
      return new yup.ValidationError([
        new yup.ValidationError(
          'Range Start cannot be greater than Range End.',
          entryNumberRangeStart,
          'entryNumberRangeStart'
        ),
        new yup.ValidationError(
          'Range End cannot be lesser than Range Start.',
          entryNumberRangeEnd,
          'entryNumberRangeEnd'
        )
      ])
    }
    return true;
  }
)